module.exports = __webpack_public_path__ + "img/parking_selected.4b998959.svg";